import * as React from "react"
import { Row, Col } from "react-bootstrap"

import { Video } from "../components/home/Video"
import { Contact } from '../components/Contact'
import { Layout } from '../components/Layout'

import "@fontsource/nunito-sans/200.css"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { graphql } from "gatsby"

const IndexPage = (props) => {

  const bioRichText = JSON.parse(props.data.contentfulPageContent.shortBio.raw)

  return (
    <Layout title="Will Frampton - Composer">
      <Row>
        <Col>
          <Video />
        </Col>
      </Row>
      <Row>
        <Col style={{ marginTop: "30px" }}>
          {documentToReactComponents(bioRichText)}
        </Col>
      </Row>
      <Row>
        <Col><h2>Contact</h2></Col>
      </Row>
      <Row className="justify-content-center">
        <Contact />
      </Row>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
{
  contentfulPageContent(identifier:{ eq: "default" }) {
    shortBio {
      raw
    }
  }
}
`